export const cityColumns = [
  { field: 'cityName', headerName: 'City name', width: 400 },
]
